var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#staticEmoji_svg__clip0_4483_330797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0a15 15 0 100 30 15 15 0 000-30zm5.49 9.61a1.924 1.924 0 11.005 3.848 1.924 1.924 0 01-.004-3.848zm-10.98 0a1.925 1.925 0 11.003 3.849 1.925 1.925 0 01-.004-3.85zm13.937 9.215c-.63 3.594-4.172 6.087-8.447 6.087-4.275 0-7.816-2.493-8.445-6.087a.727.727 0 01-.012-.11c0-.52.631-.855 1.184-.666 2.132.736 4.618 1.111 7.275 1.111s5.143-.375 7.275-1.11c.55-.198 1.184.143 1.184.665a.72.72 0 01-.014.11z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "staticEmoji_svg__clip0_4483_330797"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
export default SvgStaticEmoji;